import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {store} from './store/helpers'
import 'moment/locale/pl';

const app = (
    <Provider store={store}>
        <MuiThemeProvider>
            <BrowserRouter basename='/calendar' >
                <App />
            </BrowserRouter>
        </MuiThemeProvider>
    </Provider>
)

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js